import React from 'react';
import { FiZap, FiMapPin, FiBriefcase, FiClock, FiTag, FiArrowUpRight } from 'react-icons/fi';
import { FaRocket, FaLightbulb, FaHandshake } from 'react-icons/fa';
import { triggerApplyModal } from '../App';
import './Careers.css';

const Careers = () => {
  const jobListings = [
    {
      id: 'fullstack',
      title: 'Senior Full Stack Engineer',
      department: 'Engineering',
      location: 'Hisar, Haryana / Remote',
      type: 'Full Time',
      experience: '3-5 Years',
      desc: 'Looking for an experienced Full Stack Engineer proficient in React, Next.js, Node.js, and cloud architectures.',
      skills: ['React.js', 'Next.js', 'Node.js', 'TypeScript', 'REST APIs', 'PostgreSQL / MongoDB']
    },
    {
      id: 'mobile',
      title: 'Mobile Application Developer',
      department: 'Mobile Engineering',
      location: 'Hisar, Haryana / Hybrid',
      type: 'Full Time',
      experience: '2-4 Years',
      desc: 'Build cross-platform iOS & Android mobile apps using Flutter or React Native with secure API integrations.',
      skills: ['Flutter', 'React Native', 'Dart', 'State Management', 'REST APIs']
    },
    {
      id: 'uiux',
      title: 'UI/UX Product Designer',
      department: 'Design',
      location: 'Hisar, Haryana / Remote',
      type: 'Full Time',
      experience: '2+ Years',
      desc: 'Craft intuitive and modern user interfaces for enterprise web apps and mobile products.',
      skills: ['Figma', 'User Research', 'Design Systems', 'Wireframing', 'Prototyping']
    },
    {
      id: 'cloud',
      title: 'Backend & Cloud Architect',
      department: 'Infrastructure',
      location: 'Hisar, Haryana / Remote',
      type: 'Full Time',
      experience: '4+ Years',
      desc: 'Design high-concurrency microservices, cloud backend infrastructure (GCP/AWS), and CI/CD pipelines.',
      skills: ['Docker', 'Kubernetes', 'GCP', 'Node.js', 'Redis', 'PostgreSQL']
    },
    {
      id: 'bde',
      title: 'Business Development Executive (IT)',
      department: 'Sales & Growth',
      location: 'Hisar, Haryana',
      type: 'Full Time',
      experience: '1-3 Years',
      desc: 'Drive client acquisition, pitch custom software services to businesses, and write project proposals.',
      skills: ['IT Lead Generation', 'Client Pitching', 'B2B Sales', 'Proposal Writing']
    },
    {
      id: 'intern',
      title: 'Software Development Intern',
      department: 'Engineering',
      location: 'Hisar, Haryana',
      type: 'Internship (6 Months)',
      experience: 'Fresher / Student',
      desc: 'Get hands-on mentorship on real client projects using JavaScript, React, Node.js, and git workflows.',
      skills: ['JavaScript', 'HTML/CSS', 'React Basics', 'Git']
    }
  ];

  return (
    <div className="careers-page">
      <div className="fintech-container">
        {/* Hero */}
        <div className="careers-hero">
          <span className="section-eyebrow">CAREERS AT KUBERSETU INFOTECH</span>
          <h1 className="gradient-text">Build Great Tech. Grow Your Career.</h1>
          <p className="careers-hero-desc">
            At Kubersetu Infotech, we build custom web applications, mobile platforms, and cloud solutions. Join an agile, engineering-driven team where your work makes a direct impact.
          </p>
        </div>

        {/* Culture & Perks */}
        <div className="careers-perks-grid">
          <div className="perk-card">
            <div className="perk-icon"><FaRocket /></div>
            <h3>High-Impact Projects</h3>
            <p>Work on modern enterprise and fintech software built for high scale and bank-grade security.</p>
          </div>
          <div className="perk-card">
            <div className="perk-icon"><FiZap /></div>
            <h3>Modern Tech Stack</h3>
            <p>We work with cutting-edge tech—React, Next.js, Node.js, Flutter, TypeScript, Docker, and GCP.</p>
          </div>
          <div className="perk-card">
            <div className="perk-icon"><FaLightbulb /></div>
            <h3>Continuous Growth</h3>
            <p>Regular technical sessions, peer code reviews, and clear engineering growth tracks.</p>
          </div>
          <div className="perk-card">
            <div className="perk-icon"><FaHandshake /></div>
            <h3>Great Work Culture</h3>
            <p>Zero bureaucracy, open feedback, collaborative team environment, and work-life balance.</p>
          </div>
        </div>

        {/* Open Roles */}
        <div className="section-header">
          <span className="section-eyebrow">OPEN OPPORTUNITIES</span>
          <h2>Current Job Openings</h2>
        </div>

        <div className="jobs-list">
          {jobListings.map((job) => (
            <div className="job-card" key={job.id}>
              <div className="job-info">
                <h3>{job.title}</h3>
                <div className="job-tags">
                  <span className="job-tag location"><FiMapPin /> {job.location}</span>
                  <span className="job-tag"><FiBriefcase /> {job.type}</span>
                  <span className="job-tag"><FiClock /> {job.experience}</span>
                  <span className="job-tag"><FiTag /> {job.department}</span>
                </div>
                <p className="job-desc">{job.desc}</p>
                <div className="job-skills">
                  {job.skills.map((skill, idx) => (
                    <span className="skill-pill" key={idx}>{skill}</span>
                  ))}
                </div>
              </div>
              <div className="job-action">
                <button
                  type="button"
                  onClick={() => triggerApplyModal(job.title)}
                  className="btn-apply"
                >
                  Apply Now <FiArrowUpRight />
                </button>
              </div>
            </div>
          ))}
        </div>

          {/* Direct Email / Modal CTA */}
          <div
            className="careers-cta-banner"
            style={{
              marginTop: '3.5rem',
              padding: '2.5rem 1.5rem',
              background: 'rgba(15, 23, 42, 0.7)',
              border: '1px solid rgba(245, 158, 11, 0.25)',
              borderRadius: '20px',
              textAlign: 'center',
            }}
          >
            <h3 style={{ fontSize: '1.4rem', color: '#ffffff', margin: '0 0 0.5rem 0' }}>
              Don't see a matching role?
            </h3>
            <p style={{ color: '#94a3b8', fontSize: '0.95rem', margin: '0 0 1.25rem 0' }}>
              Send your resume directly to{' '}
              <a href="mailto:kubersetu@gmail.com" style={{ color: '#f59e0b', fontWeight: '600' }}>
                kubersetu@gmail.com
              </a>{' '}
              or click below to submit a general application.
            </p>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => triggerApplyModal('Other / General Application')}
              style={{ padding: '0.75rem 1.75rem', fontSize: '0.95rem' }}
            >
              Submit General CV <FiArrowUpRight />
            </button>
          </div>
      </div>
    </div>
  );
};

export default Careers;
